import React from 'react';
import type { FC, ReactNode } from 'react';
import { createPortal } from 'react-dom';

import { MODAL_Z_INDEX } from '@/common/z-index';

interface ModalProps {
    isOpen: boolean;
    children: ReactNode;
}

export const Modal: FC<ModalProps> = ({ isOpen, children }) => {
    return createPortal(
        <div
            className={`fixed inset-0 flex ${isOpen ? 'opacity-100 visible' : 'opacity-0 invisible'}
                        items-center justify-center
                        bg-black bg-opacity-50`}
            style={{ zIndex: MODAL_Z_INDEX }}
        >
            {children}
        </div>,
        document.body,
    );
};
